module.exports = __webpack_public_path__ + "img/logo-vega-azul.3a6298c8.png";